"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setApiClient = exports.getApiClient = void 0;
var apiClient;

var getApiClient = function getApiClient() {
  return apiClient;
};

exports.getApiClient = getApiClient;

var setApiClient = function setApiClient(_apiClient) {
  apiClient = _apiClient;
};

exports.setApiClient = setApiClient;


//////////////////
// WEBPACK FOOTER
// ./js/utils/apiClient.js
// module id = 293
// module chunks = 209 210 211 212